<template>
  <div class="follow-up follow-up--instructions">
    <div class="block block-default text-center">
      <h3 class="mb-5">
        {{ data.title }}
      </h3>
      <div v-dompurify-html="data.body" />
    </div>
    <contact-button :data="data.form" />
    <contact-options
      :options="data.contact_options"
      :calculate-width="calculateWidth"
    />
  </div>
</template>

<script>
import ContactButton from 'app/components/shared/contact-button'
import ContactOptions from 'app/components/shared/contact-options'

export default {
  name: 'Instruction',
  components: {
    ContactButton,
    ContactOptions
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      calculateWidth: true
    }
  }
}
</script>
